<template>
  <div class="ivy-content-container">
    <div class="ivy-cover-box">
      <img src="../../../static/ivy-logo-new.png" alt="" />
    </div>
    <div class="qr-content">
      <div class="qr-text">长按识别二维码给宝宝起名</div>
      <div class="qr-cover-box">
        <img
          crossOrigin="anonymous"
          src="../../../static/server-qr.jpg"
          alt="关注常青藤爸爸学堂"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less">
@import (reference) url(../../../project.less);
.ivy-content-container {
  padding: 20px 0;
  .cells;
  align-items: center;
  .ivy-cover-box {
    width: 203px;
    height: 100px;
    img {
      display: block;
      width: 100%;
    }
  }
  .qr-content {
    flex: 1;
    text-align: right;
    .qr-text,
    .qr-cover-box {
      .inline-block;
    }
    .qr-text {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #999999;
      text-align: right;
      width: 168px;
      padding-top: 40px;
    }
    .qr-cover-box {
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 20px;
      overflow: hidden;
      width: 150px;
      height: 150px;
      img {
        object-fit: cover;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
